<div class="home-wrapper">
  <app-toolbar />
  <div class="home">
    <section class="hero">
      <h1>
        Welcome to the AstraZeneca<br />
        Binding Corporate Rules Portal
      </h1>
      <p class="lead">
        Access and oversee your entire BCR documentation quickly and efficiently—all in one place.
      </p>
    </section>
    <section class="modules">
      <h2>BCR Modules</h2>
      <div class="module-grid">
        @for (item of navItems; track trackByNav($index, item)) {
          <div class="module-card">
            <a
              class="module-link"
              [routerLink]="item.route || '/home'"
              [attr.aria-label]="item.label"
              routerLinkActive="active"
            >
              {{ item.label }}
            </a>
            @if (item.description) {
              <span class="module-desc">{{ item.description }}</span>
            }
          </div>
        }
      </div>
    </section>
  </div>
  <app-footer />
</div>
